import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import './LanguageFlag.scss';
import { setLanguageId, setUiLanguageId } from '../redux/actions/baseActions';

const LanguageFlag = ({setLanguageId, setUiLanguageId}) => {

  const changeLanguageId = (id) => {
    setUiLanguageId(id);
    setLanguageId(id === 3 ? 1 : id);
  };

  return (
    <div className="language-flag">      
        <div className="lang_eng" onClick={ () => { changeLanguageId(1); } }> </div>
        <div className="lang_heb" onClick={ () => { changeLanguageId(2); } }> </div>
        <div className="lang_ru" onClick={ () => { changeLanguageId(3); } }> </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
    currentUiLanguageId
  } = state;

  return {
    currentLanguageId,
    currentUiLanguageId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLanguageId,
      setUiLanguageId
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(LanguageFlag);